// src/context/NotificationContext.jsx
import React, { createContext, useContext, useState, useCallback } from "react";
import NotificationModal from "../components/NotificationModal/NotificationModal";

const NotificationContext = createContext(null);

export function NotificationProvider({ children }) {
    const [show, setShow] = useState(false);
    const [title, setTitle] = useState("Notification");
    const [message, setMessage] = useState("");
    const [primaryAction, setPrimaryAction] = useState({ label: "OK", onClick: () => {} });

    const notify = useCallback(({ title, message, action } = {}) => {
        setTitle(title || "Notification");
        setMessage(message || "");

        if (typeof action === "function") {
            setPrimaryAction({ label: "OK", onClick: action });
        } else if (action && typeof action === "object") {
            const label = action.label ?? "OK";
            const onClick = typeof action.onClick === "function" ? action.onClick : () => {};

            setPrimaryAction({ label, onClick });
        } else {
            setPrimaryAction({ label: "OK", onClick: () => {} });
        }

        setShow(true);
    }, []);

    const hide = useCallback(() => {
        setShow(false);
        setTitle("Notification");
        setMessage("");
        setPrimaryAction({ label: "OK", onClick: () => {} });
    }, []);

    return (
        <NotificationContext.Provider value={{ notify, hide }}>
        {children}

        {/* Pass an OBJECT with label/onClick to the modal */}
        <NotificationModal
            show={show}
            onHide={hide}
            title={title}
            message={message}
            action={{
            label: primaryAction.label,
                onClick: () => {
                    try { primaryAction.onClick(); } finally { hide(); }
                }
            }}
            backdrop="static"
            keyboard={false}
        />
        </NotificationContext.Provider>
    );
}

export function useNotification() {
    const ctx = useContext(NotificationContext);

    if (!ctx) throw new Error("useNotification must be used within NotificationProvider");
    return ctx;
}